import { CircularProgress } from "@mui/material";
import "./loader.css";

const Loader = () => {
  return (
    <div className="loader_content">
      {/* <span className="loader"></span> */}
      <CircularProgress sx={{ fontSize: 50 }} className="loader" />
    </div>
  );
};

export default Loader;
